import { Divider, Flex, Image } from '@mantine/core';

import konnectMD from '@/assets/img/partners/konnect-md-2.png';
import { useIsNewEzFileUi } from '@/flagsmith';
import { useFields } from '@/routes/hooks/useFields';
import { useMdBreakpoint } from '@/theme/hooks/useMdBreakpoint';
import { isFinFitPartnership, partnerSvgLogoMap } from '@/utils/partnership';
import { isDarkBackground } from '@/utils/showLayoutElements';
import { isLoaderProductStep, isSavingLoaderStep } from '@/utils/stepUtils';

type PartnershipProps = {
  stepId: string;
};

export const Partnership = ({ stepId }: PartnershipProps) => {
  const fields = useFields();
  const partnership = fields?.partner;
  const isNewEzFileUi = useIsNewEzFileUi();
  const isDark =
    isDarkBackground(stepId, isNewEzFileUi) ||
    isLoaderProductStep(stepId) ||
    isSavingLoaderStep(stepId);
  const isSvg = isFinFitPartnership(`${partnership}`);
  const isMdBreakpoint = useMdBreakpoint();

  const logoSrc = konnectMD;
  const SvgComponent = partnerSvgLogoMap.get(`${partnership}`);

  return (
    <Flex
      align="center"
      style={{
        zIndex: 1,
        marginLeft: 16,
        borderLeft: '1px solid #BCBCBC',
      }}
    >
      <Divider
        orientation="vertical"
        sx={{ height: '50%' }}
      />
      {isSvg && SvgComponent ? (
        <Flex ml={16}>
          <SvgComponent
            width={!isMdBreakpoint ? 60 : 78}
            height={!isMdBreakpoint ? 20 : 30}
            color={isDark ? 'white' : '#1d47f3'}
          />
        </Flex>
      ) : (
        <Image
          src={logoSrc}
          style={{
            width: !isMdBreakpoint ? 60 : 134,
            marginLeft: 16,
            marginBottom: 15,
          }}
        />
      )}
    </Flex>
  );
};
